import React, {useEffect, useState} from "react";
import Container from 'react-bootstrap/Container';
import '../lg/Lg.css';
import './Lrrh.css';
import {logPageOpened} from "../model/utils";
import {TildaB} from "../lg/widgets/common/TildaB";
import {
    calcMotivationForNextLm,
    calcNameOfConcert, calcNectLmUrl,
    calcNextLmButtonName, calculateLeadGenerationUrl, calculateShortPageUrlLRRH, calculateShortPageUrlNew,
    calcWhere,
    registerClick
} from "../lg/widgets/common/LgHelper";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {lgSetup} from "../../backend/LgSetup";
import {sendHeight} from "../../resizer";
import {getObjectFromCache, saveObjectToCache} from "../../logic_tmp/storage/DataCache";
import {registerConcersion} from "../../logic/funel/FacebookUtils";
let nextLm
let bannerImage

export function LrrhFooter() {
    const [isLoading, setLoading] = useState(true)
    appdata.viewType = "LeadMagnetPage"
    useEffect(() => {
        let counters =  getObjectFromCache("NEVEREXPIREDCOUNTER", "LRRH_LM_COUNTERS")
        if (counters === undefined)
        {
            counters = {
                lmCounter: 1
            }
        }
        counters.lmCounter = counters.lmCounter + 1
        saveObjectToCache("NEVEREXPIREDCOUNTER","LRRH_LM_COUNTERS", counters)

        if (counters.lmCounter % 3 === 0)
        {
            //registerConcersion('ViewContent');
        }
        logPageOpened(appdata.parentPath, appdata.viewType)
        nextLm = lgSetup.lms[appdata.nextLmKey]
        bannerImage = "/cfg/" + nextLm["bannerResource"]
        setLoading(false)
    }, []);
    return (
        <div>
            {isLoading?<div>...</div>:
                <Container>
                    <TildaB>
                        <span className="normal">{calcMotivationForNextLm(appdata)}</span>
                    </TildaB>
                    <TildaB>
                        <a onClick={() => registerClick(appdata, "NextLm", appdata.nextLmKey, "LeadMagnetPage")}
                           href={calcNectLmUrl(appdata)} target="_parent">
                            <img className="fit-picture" src={bannerImage} onLoad={() => sendHeight("IMGLogo")}
                                 alt="Grapefruit slice atop a pile of other slices" width="100%" href={calcNectLmUrl(appdata)}/>
                        </a>
                    </TildaB>
                    <TildaB>
                        <a id="toNextLm" onClick={() => registerClick(appdata, "NextLm", appdata.nextLmKey, "LeadMagnetPage")}
                           href={calcNectLmUrl(appdata)} target="_parent"
                           className="myButton myButtonYellow myButtonLrrh ">{calcNextLmButtonName(appdata)}</a>
                    </TildaB>
                    <TildaB>
                        <span className="normal">Хотите получать уведомления, когда у нас появится новая история?</span>
                        <br/>
                        <br/>
                        <span className="normal">Узнайте больше о проекте 'Красные Шапочки и искусственный интеллект' и подпишитесь на новые истории!</span>
                    </TildaB>
                    <TildaB>
                        <a id="toConcertShort" href={calculateShortPageUrlLRRH(appdata)} target="_parent"
                           className="myButton">{"Узнать больше!"}</a>
                    </TildaB>
                </Container>
            }
        </div>
    )
}

